import React, { useState } from 'react';
import { Dropdown as AntdDropdown } from 'antd';
import { Popup } from 'antd-mobile';
import classNames from 'classnames';

interface MenuItem {
  icon?: React.ReactNode;
  label?: string | React.ReactNode;
  onClick?: () => void;
  type?: 'warning' | 'hoverRed';
  active?: boolean;
}

const selectIcon = () => (
  <svg width='16' height='16' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3 8.5L7.5 13L15.5 5'
      stroke='var(--col_brand00)'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

interface DropdownProps {
  children: React.ReactNode; // 按钮内的内容
  menu: MenuItem[];
  placement?: 'bottomRight' | 'bottomLeft' | 'topRight' | 'topLeft';
}

const Dropdown: React.FC<DropdownProps> = ({ children, menu, placement = 'bottomRight' }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  // 按钮样式的基础类

  const onTouchstart = (e: React.TouchEvent) => {
    // 双指操作不触发关闭
    if (e.changedTouches.length !== 1) return;
    const startY = e.changedTouches[0].pageY;
    const onTouchend = (e: TouchEvent) => {
      // 优先注销事件
      document.removeEventListener('touchend', onTouchend);

      const endY = e.changedTouches[0].pageY;
      if (endY - startY > 10) {
        onClose();
      }
    };
    const onContextmenu = () => {
      // 长按有可能触发菜单，这时候要注销touchend事件
      document.removeEventListener('touchend', onTouchend);
      document.removeEventListener('contextmenu', onContextmenu);
    };
    document.addEventListener('touchend', onTouchend);
    document.addEventListener('contextmenu', onContextmenu);
  };

  const onClose = () => {
    setPopoverOpen(false);
  };

  const menuItems = menu.map((item, index) => ({
    key: `${item.label || ''}_${index}`,
    label: (
      <div
        className={`md:hover:bg-col_bg14 flex cursor-pointer items-center px-2 py-2 text-[14px] font-medium ${
          item.type === 'warning' ? 'text-col_accent01' : 'text-col_text00'
        } ${item.type === 'hoverRed' && 'md:hover:text-col_accent01'} ${
          item.active && 'bg-col_bg14'
        }`}
        onClick={item?.onClick}
      >
        <div
          className={classNames(
            'text-col_text00 relative flex w-full items-center gap-1 rounded-[8px] md:min-w-[108px]',
            item.active && 'md:w-[172px]',
          )}
        >
          {item.icon && (
            <div
              className={`flex h-[28px] w-[28px] items-center justify-center ${
                item.type === 'warning' ? 'text-col_accent01' : ''
              }`}
            >
              {item.icon}
            </div>
          )}
          <div
            className={`flex items-center gap-1 text-[16px] md:text-[13px] ${
              item.type === 'warning' ? 'text-col_accent01' : ''
            }`}
          >
            {item.label}
          </div>
          {item.active && (
            <div className='absolute right-0 top-1/2 -translate-y-1/2 md:right-2'>
              {selectIcon()}
            </div>
          )}
        </div>
      </div>
    ),
  }));

  return (
    <>
      <div className='hailuo-dropdown hidden md:block'>
        <AntdDropdown
          overlayClassName={`hailuo-dropdown space-x-[2px] ${
            menuItems.length > 1 ? 'more-items' : ''
          }`}
          menu={{
            items: menuItems,
          }}
          placement={placement}
        >
          {children}
        </AntdDropdown>
      </div>
      <div className='md:hidden'>
        <div onClick={() => setPopoverOpen(true)}>{children} </div>
        <Popup
          visible={popoverOpen}
          closeOnSwipe={true}
          closeOnMaskClick={true}
          position='bottom'
          className='md:hidden'
          bodyClassName='rounded-t-2xl bg-col_bg09 miniprogram-phone-bar'
          onClose={onClose}
        >
          <div className='w-full select-none px-4 pb-3'>
            {/* 下拉滑块 */}
            <div
              className='slider-box mx-auto w-8 rounded-sm pb-2 pt-[10px]'
              onTouchStart={onTouchstart}
            >
              <div className='bg-col_text03 h-[5px] w-8 rounded-[4px] opacity-50' />
            </div>

            {menu.map((item, index) => (
              <div
                className='bg-col_fill03 relative mb-3 flex items-center justify-center rounded-xl p-4 last:mb-0'
                onClick={() => {
                  item?.onClick?.();
                  onClose();
                }}
                key={`${item.label || ''}_${index}`}
              >
                {item.icon && (
                  <span
                    className={`mr-2 ${
                      item.type === 'warning' || item.type === 'hoverRed'
                        ? 'text-col_accent01'
                        : 'text-col_text00'
                    }`}
                  >
                    {item.icon}
                  </span>
                )}
                <span
                  className={`w-full text-[15px] font-medium leading-[24px] ${
                    item.type === 'warning' || item.type === 'hoverRed'
                      ? 'text-col_accent01'
                      : 'text-col_text00'
                  }`}
                >
                  {item.label}
                </span>
                {item.active && (
                  <div className='absolute right-4 top-1/2 -translate-y-1/2'>{selectIcon()}</div>
                )}
              </div>
            ))}
          </div>
        </Popup>
      </div>
    </>
  );
};

export default Dropdown;
